import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-item',
  templateUrl: './product-item.component.html',
  styleUrls: ['./product-item.component.scss'],
})
export class ProductItemComponent implements OnInit {

  animationSequence: any[] = [];
  @Input() product: any;
  minQuantity;

  constructor() { }

  ngOnInit(): void {
    let minBoxAmount;
    // minimale doos inhoud bepalen
    // als geen van de testen waar zijn zal er geen minimale doos inhoud zijn.
    // als binnendoos gevult is en groter is dan 1
    if (this.product.packing.binnendoos > 1) {
      // gebruik binnendoos als minimale doos inhoud
      minBoxAmount = this.product.packing.binnendoos;
      // als omdoos gevult is
    } else if (this.product.packing.omdoos) {
      // gebruik omdoos als minimale doos inhoud
      minBoxAmount = this.product.packing.omdoos;
    }

    // haal een copy van de 2e staffel op
    let [, secStaffel] = JSON.parse(JSON.stringify(this.product.graduatedPrices));

    // als 2 staffel bestaat maar aantal is fout ingevuld. (kleiner dan 1)
    if (secStaffel && secStaffel.fromamount < 1) {
      // verwijder 2e staffel om fouten hieronder te voorkomen
      secStaffel = undefined;
    }

    // eerst gevonden test die waar is wordt gebruikt
    switch (true) {
      // test: 2e staffel en minimale doos inhoud bestaat
      case secStaffel && !!minBoxAmount:
        // gebruik de laagste waarde 2e staffel of minimale doos inhoud
        this.minQuantity = Math.min(secStaffel.fromamount, minBoxAmount) * 1;
        break;
      // test: minimale doos inhoud bestaat
      case !!minBoxAmount:
        // gebruik minimale doosinhoud als deze bestaat
        this.minQuantity = minBoxAmount * 1;
        break;
      // test: 2e staffel bestaat
      case !!secStaffel:
        // gebruik 2e staffel.
        this.minQuantity = secStaffel.fromamount * 1;
        break;
    }

    // Als minimale aantal niet gezet wordt of hij wordt gezet op 0 dan overschrijven we deze met 1
    // Dit zal praktisch niet gebeurt maar theoretisch wel mogelijk bij fouten
    if (!this.minQuantity) {
      this.minQuantity = 1;
    }

    let bulkStock = this.getBulkStock();
    if (this.minQuantity > bulkStock) {
      this.minQuantity = bulkStock;
    }

    if (secStaffel && this.minQuantity >= secStaffel.fromamount) {
      this.product.graduatedPrices = this.product.graduatedPrices.splice(1);
    }
  }

  getBulkStock() {
    let result = 0;
    if (this.product && this.product.stockwarehouses) {
      const list = this.product.stockwarehouses.filter(i => i.warehouse.toUpperCase().indexOf('BULK') !== -1)
      list.forEach((i) => result += i.stock || 0);
      return result;
    }
  }


  get discountName() {
    const name = this.product.graduatedPrices.find(gp => gp.discountname)?.discountname;
    if (name) {
      return name;
    }
    if (this.product.graduatedPrices.find(gp => gp.discount)) {
      return 'Actie'
    }
  }

  get salesPrice() {
    if (this.product.discount) {
      return this.product.discount?.productprice;
    }
    const [volumePrice] = this.product.graduatedPrices
    if (volumePrice) {
      if (volumePrice.discount) {
        return ((100 - volumePrice.discount) / 100) * volumePrice.productprice
      } else {
        return volumePrice?.productprice
      }
    }
    return this.product.productprice
  }
}
